import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'dibs-elements/exports/Button';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';

// Styles
import styles from './styles/CartRemoveModal.scss';

const RemoveError = ({ message }) => {
    return <div className={styles.message}>{message}</div>;
};

RemoveError.propTypes = {
    message: PropTypes.string.isRequired,
};

const ConfirmRemove = ({ isLoading, onClick }) => {
    return (
        <div>
            <div className={styles.confirm}>
                <FormattedMessage
                    id="CartRemoveModal.message"
                    defaultMessage="Are you sure you want to remove this item from your cart?"
                />
            </div>
            <Button
                className={styles.ctaFull}
                dataTn="portfolio-remove-item-confirm"
                onClick={onClick}
                disabled={isLoading}
            >
                <FormattedMessage id="CartRemoveModal.buttom" defaultMessage="Yes, Remove" />
            </Button>
        </div>
    );
};

ConfirmRemove.propTypes = {
    onClick: PropTypes.func.isRequired,

    isLoading: PropTypes.bool,
};

const CartRemoveModal = ({ showModal, isLoading, hasError, onClose, onClick }) => (
    <ModalContainer isOpen={showModal} onClose={onClose} closeOnEsc modalPosition="center">
        <BarHeader
            title={
                hasError ? (
                    <FormattedMessage
                        id="CartRemoveModal.errorTitle"
                        defaultMessage="Sorry, an error has occurred"
                    />
                ) : (
                    <FormattedMessage id="CartRemoveModal.title" defaultMessage="Remove Item" />
                )
            }
        />
        <ModalCloseButton onClick={onClose} />
        <ModalBody>
            {hasError ? (
                <div className={styles.message}>
                    <FormattedMessage
                        id="CartRemoveModal.errorMessage"
                        defaultMessage="Please try refreshing the page/Please try refreshing the page."
                    />
                </div>
            ) : (
                <ConfirmRemove onClick={onClick} isLoading={isLoading} />
            )}
        </ModalBody>
    </ModalContainer>
);

CartRemoveModal.defaultProps = {
    error: {},
};

CartRemoveModal.propTypes = {
    showModal: PropTypes.bool,
    onClose: PropTypes.func,
    onClick: PropTypes.func,
    isLoading: PropTypes.bool,
    hasError: PropTypes.bool,
};

export default CartRemoveModal;
